import SelectVM from './select-vm';
export default {
  init: function(){
    var data = {};
    data.terms = JSON.parse($('#terms_json').val());
    data.institutions = JSON.parse($('#institutions_json').val());
    var node = document.getElementById('main-pjax-container');
    ko.cleanNode(node);
    var vm = new SelectVM(data);
    ko.applyBindings(vm,node);
  }
};

